import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Courses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/courses');
      setCourses(response.data);
    } catch (error) {
      console.error('Failed to fetch courses:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Courses</h1>
        <p className="page-subtitle">Manage learning paths and course structures</p>
      </div>

      {message && (
        <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-error'}`}>
          {message.text}
        </div>
      )}

      <div style={{ marginBottom: '20px' }}>
        <button className="btn btn-primary">+ Add Course</button>
      </div>

      {courses.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎓</div>
          <h3>No courses yet</h3>
          <p style={{ color: 'rgba(243, 234, 255, 0.6)', marginBottom: '20px' }}>
            Create your first course to organize learning paths
          </p>
          <button className="btn btn-primary">Create Course</button>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '20px' }}>
          {courses.map((course) => (
            <div key={course._id} className="card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <h3 style={{ marginBottom: '8px' }}>{course.name}</h3>
                  <p style={{ color: 'rgba(243, 234, 255, 0.6)', marginBottom: '16px' }}>
                    {course.source_lang} → {course.target_lang}
                  </p>
                  
                  {course.description && (
                    <p style={{ marginBottom: '16px' }}>{course.description}</p>
                  )}

                  <div>
                    <strong>Learning Path:</strong>
                    <div style={{ marginTop: '12px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {course.path.map((node, index) => (
                        <div
                          key={index}
                          style={{
                            background: 'rgba(126, 63, 242, 0.2)',
                            padding: '8px 12px',
                            borderRadius: '8px',
                            fontSize: '13px'
                          }}
                        >
                          <div style={{ fontWeight: 'bold' }}>{node.name}</div>
                          <div style={{ fontSize: '11px', color: 'rgba(243, 234, 255, 0.6)' }}>
                            #{node.start_index} - #{node.end_index}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '8px' }}>
                  <span className={`badge ${course.enabled ? 'badge-success' : 'badge-danger'}`}>
                    {course.enabled ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </div>

              <div style={{ marginTop: '16px', display: 'flex', gap: '8px' }}>
                <button className="btn btn-secondary">Edit</button>
                <button className="btn btn-secondary">Toggle Status</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Courses;

